interface dynamicTextProps {
  key: 'BROKEN_PRODUCT' | 'WRONG_PRODUCT' | 'INCOMPLETE_PRODUCT' | 'FAKE_PRODUCT' | 'DIFFERENT_PRODUCT' | 'OTHER';
}

const dynamicText = ({ key }: dynamicTextProps) => {
  let str = '';

  switch (key) {
    case 'BROKEN_PRODUCT':
      str = 'Se você quiser, você pode trocar ou devolver o produto.';
      break;
    case 'WRONG_PRODUCT':
      str = 'Se precisar de ajuda, você pode trocar ou devolver o produto ou falar com o nosso atendimento pelo chat.';
      break;
    case 'INCOMPLETE_PRODUCT':
      str = 'Se precisar de ajuda, você pode trocar ou devolver o produto ou falar com o nosso atendimento pelo chat.';
      break;
    case 'FAKE_PRODUCT':
      str = 'Se você precisar, é só falar com o nosso atendimento pelo chat.';
      break;
    case 'DIFFERENT_PRODUCT':
      str = 'Se você precisar, é só falar com o nosso atendimento pelo chat.';
      break;
    case 'OTHER':
      str = 'Se você precisar, é só falar com o nosso atendimento pelo chat.';
      break;
    default:
      console.error('dynamicText receive key incorrect');
      break;
  }
  return str;
};

export default dynamicText;
export { dynamicText };
